import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { CollectPayment } from "../Services/API";
import { FlightBooking } from "../Services/API";

const REACT_APP_API = process.env.REACT_APP_API_BASE_URL;

const PayNBook = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [paymentError, setPaymentError] = useState("");
  const [termsError, setTermsError] = useState("");
  const [message, setMessage] = useState("");
  const [flightDetails, setFlightDetails] = useState(null);
  const [flightAvailibilies, setFlightAvailibilies] = useState(null);
  const [oF, setOF] = useState(null);
  const [rF, setRF] = useState(null);
  const [totalBFare, setTotalBFare] = useState(0);
  const [totalFare, setTotalFare] = useState(0);
  const [adultTotalBaseFare, setAdultTotalBaseFare] = useState(0);
  const [childTotalBaseFare, setChildTotalBaseFare] = useState(0);
  const [infantTotalBaseFare, setInfantTotalBaseFare] = useState(0);
  const [paxCount, setPaxCount] = useState(null);

  useEffect(() => {
    const token = searchParams.get("token");
    const productType = "Flight";

    if (!token) {
      setMessage("Invalid approval link.");
      setLoading(false);
      return;
    }

    fetch(`${REACT_APP_API}/api/Organization/PaymentLink/GetFlightBookingDetails?token=${token}&productType=${productType}`)
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text);
        }
        return res.json();
      })
      .then((data) => {
        console.log(data);
        
        setFlightDetails(data.data);
        //setFlightAvailibilies(data.data);
        setFlightAvailibilies(data.data?.airBookingResponse || []);

        //const OF = data.data?.flightAvailibilies?.[0]?.segments?.filter(t => t.flightCount === 1) || [];
        //const RF = data.data?.flightAvailibilies?.[1]?.segments?.filter(t => t.flightCount === 1) || [];
        const OF = data.data?.airBookingResponse[0]?.flightDetails?.filter(t => t.flightCount === 0) || [];
        const RF = data.data?.airBookingResponse[0]?.flightDetails?.filter(t => t.flightCount === 1) || [];
        setOF(OF);
        setRF(RF);

        // console.log("OF lenght:", OF.length);
        // console.log("OF:", OF);
        // console.log("RF:", RF);
        // console.log("RF length:", RF.length);

        
        let TotalBFare = 0;
        let TotalFare = 0;
        if (data.data && data.data.airBookingResponse) {
          data.data.airBookingResponse.forEach(item => {
            TotalBFare += parseFloat(item.fareDetails.totalBaseFare || 0);
            TotalFare += parseFloat(item.fareDetails.totalFare || 0);
          });
        }
        setTotalBFare(TotalBFare);
        setTotalFare(TotalFare);

        const OB = [...data.data.airBookingResponse];
        //console.log("OB:", OB[0].adult);
        setPaxCount(OB);

        let adultTotalBaseFare = 0;
        if (data.data.airBookingResponse && data.data.airBookingResponse.length > 0) {
          data.data.airBookingResponse.forEach((flight) => {
            flight.fareDetails.paxFareDetails.forEach((pax) => {
              if (pax.paxType === "ADT") {
                adultTotalBaseFare += Number(pax.paxBaseFare);
              }
            });
          });
        }
        setAdultTotalBaseFare(adultTotalBaseFare)

        let childTotalBaseFare = 0;
        if (data.data.airBookingResponse && data.data.airBookingResponse.length > 0) {
          data.data.airBookingResponse.forEach((flight) => {
            flight.fareDetails.paxFareDetails.forEach((pax) => {
              if (pax.paxType === "CHD") {
                childTotalBaseFare += Number(pax.paxBaseFare);
              }
            });
          });
        }
        setChildTotalBaseFare(childTotalBaseFare)

        let infantTotalBaseFare = 0;
        if (data.data.airBookingResponse && data.data.airBookingResponse.length > 0) {
          data.data.airBookingResponse.forEach((flight) => {
            flight.fareDetails.paxFareDetails.forEach((pax) => {
              if (pax.paxType === "INFT") {
                infantTotalBaseFare += Number(pax.paxBaseFare);
              }
            });
          });
        }
        setInfantTotalBaseFare(infantTotalBaseFare)
        setMessage(data.message);
      })
      .catch(() => {
        setMessage("Invalid or expired approval link.");
      })
      .finally(() => {
        setLoading(false);
      });

  }, [searchParams]);

  const handlePaymentSubmit = async () => {
    setPaymentError("");
    setTermsError("");
    setSuccess("");

    // Payment Method Validation
    if (!paymentMethod) {
      setPaymentError("Please select a payment method before continuing.");
      return;
    }

    // Terms Checkbox Validation
    if (!acceptedTerms) {
      setTermsError("Please accept the Terms & Conditions before continuing.");
      return;
    }
    try {
      setLoading(true);

      const requestBody = {
        transactionID: flightDetails?.referenceNo,
        referenceNo: flightDetails?.referenceNo,
        corporateCode: flightDetails?.corporateDetails?.companyId,
        userId: flightDetails?.corporateDetails?.userName,
        service: "Flight",
        sessionId: flightDetails?.airBookingResponse[0]?.sessionID,
        transactionType: "",
        remarks: "",
        totalAmount: flightDetails.airBookingResponse[0]?.grandTotalFare,
        creditLimit: true,
        status: "",
        paymentMode: {
          paymentModeType: "",
          cardType: "",
          productType: "",
          pgProvider: paymentMethod
        },
        ipAddress: "",
      };

      //call here Api To collect Payment 
      const response = await CollectPayment(requestBody);
      console.log("webPaymentLink", response.formHtml);
      if (response?.success === true && response?.message === "Payment form generated.") {
        window.open(response.formHtml, "_self");
        //window.open(response.formHtml, "_blank");
      }

      else if (response?.success === true) {
        setSuccess("Payment successful!!");
        const response = await FlightBooking({
          clientCode: "BerryJourneys",
          userID: flightDetails?.corporateDetails?.userName,
          key: flightDetails?.airBookingResponse[0]?.sessionID,
          referenceNo: flightDetails?.referenceNo,
        });

        navigate(`/thankyou?ReferenceNo=${flightDetails?.referenceNo}`);

      } else {
        setPaymentError(response?.message || "Payment fail. Try again.");
      }
    } catch (error) {
      console.error("Payment API Error:", error);
      setPaymentError("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <p class="text-center load"><span class="loader"></span></p>
      )}
      <section className='Booking_flight'>
        <div className='container_box'>
          <div className='row'>
            <div className='col-md-9'>
              <div className='box_shadow'>
                <div className="col-md-12 col-lg-12">
                  <h4 className="sub_heading">Review Your Booking</h4>
                  {Array.isArray(flightAvailibilies) && flightAvailibilies.length > 0 && (
                    flightAvailibilies[0]?.tripType === 3 ? (
                      <>
                        <div className="row">
                          {/* <div className="col-lg-12">
                            <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                            <div className="row">
                              <div className="col-md-2">
                                <div className="flight_img">
                                  <img
                                    className="img_icon"
                                    src={`/assets/images/flight/${selectedFlight?.segments?.[0]?.airLineCode}.png`}
                                    alt={selectedFlight?.segments?.[0]?.airLineName || "flight"}
                                    onError={(e) => {
                                      e.target.src = "/assets/images/flight/flight_v.png"; // fallback
                                    }}
                                  />                                    </div>
                                <div className="name_code">
                                  <span>IX - 1194</span>
                                  <span>Air India Express</span>
                                </div>
                              </div>
                              <div className="col-md-10">
                                <div className="row">
                                  <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                  <div className="col-md-3">
                                    <div className="timer">
                                      <p>Delhi</p>
                                      <h4>DEL <span>|</span> 23:30</h4>
                                      <p className="dat_Adres">Fri, 29 Aug 2025</p>
                                      <p className="dat_Adres">Delhi Indira Gandhi Intl,Terminal 1</p>
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="deruation">
                                      <p>02:15  |  0 STOP </p>
                                      <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                      <p className="">
                                        <span>Economy </span>
                                        <span>Partial Refundable</span>
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="timer">
                                      <p>Mumbai</p>
                                      <h4>BOM <span>|</span> 01:45</h4>
                                      <p className="dat_Adres">Sat, 30 Aug 2025</p>
                                      <p className="dat_Adres">Chhatrapati Shivaji,Terminal 2</p>
                                    </div>
                                  </div>
                                  <div className="col-md-3">
                                    <div className="baggage">
                                      <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                      <p>Check-in :<strong>15 Kg / person</strong></p>
                                      <p>Cabin :<strong>07 Kg/ person</strong></p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </>
                    ) : (
                      <>
                        {oF && oF.length > 0 && (
                          <>
                            <div className="row">
                              {oF.map((segment, index) => (
                                <div className="col-lg-12" key={index}>
                                  <p className="departure"><i className="fa fa-plane"></i> Departure</p>
                                  <div className="row">
                                    <div className="col-md-2">
                                      <div className="flight_img">
                                        <img className="img_icon" src={`/assets/images/Flight_Images/${segment.marketingCarrier}.gif`} alt="flight" />
                                      </div>
                                      <div className="name_code">
                                        <span>{segment.airLineCode} - {segment.flightNumber}</span>
                                        <span>{segment.airLineName}</span>
                                      </div>
                                    </div>
                                    <div className="col-md-10">
                                      <div className="row">
                                        <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                        <div className="col-md-3">
                                          <div className="timer">
                                            <p>{segment.departCityName}</p>
                                            <h4>{segment.departAirportCode} <span>|</span> {segment.departDateTime.split('T')[1].substring(0, 5)}</h4>
                                            <p className="dat_Adres"> {new Date(segment.departDateTime).toLocaleString("en-US", {
                                              weekday: "short",
                                              day: "numeric",
                                              month: "short",
                                              year: "numeric",
                                              // hour: "2-digit",
                                              // minute: "2-digit",
                                              hour12: false
                                            })}</p>
                                            <p className="dat_Adres">{segment.departAirportName}, {segment.departTerminal == "" ? "" : "Terminal " + segment.departTerminal}</p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="deruation">
                                            {segment.viaSector && segment.viaSector.trim() !== "" && segment.numberOfStops > 0 ? (
                                              <p>{segment.duration}  |  {segment.numberOfStops} STOP | {segment.viaSector}</p>
                                            ) : (
                                              <p>{segment.duration}  |  {segment.numberOfStops} STOP </p>
                                            )}

                                            <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                            <p className="">
                                              {segment.travelClass && segment.travelClass.trim() !== "" && (
                                                <span>{segment.travelClass}</span>
                                              )}

                                              {flightAvailibilies[0].isRefundable ? (
                                                <span>Partially Refundable</span>
                                              ) : (
                                                <span>Non-Refundable</span>
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="timer">
                                            <p>{segment.arrivalCityName}</p>
                                            <h4>{segment.arrivalAirportCode} <span>|</span> {segment.arrivalDateTime.split('T')[1].substring(0, 5)}</h4>
                                            <p className="dat_Adres">{new Date(segment.arrivalDateTime).toLocaleString("en-US", {
                                              weekday: "short",
                                              day: "numeric",
                                              month: "short",
                                              year: "numeric",
                                              // hour: "2-digit",
                                              // minute: "2-digit",
                                              hour12: false
                                            })}</p>
                                            <p className="dat_Adres">{segment.arrivalAirportName}, {segment.arrivalTerminal == "" ? "" : "Terminal " + segment.arrivalTerminal}</p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          {segment.baggageDetails && segment.baggageDetails.length > 0 && (
                                            <div className="baggage">
                                              <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                              <p>Check-in :<strong>{segment.baggageDetails[0].baggage} Kg / person</strong></p>
                                              <p>Cabin :<strong>{segment.baggageDetails[0].cabinBaggage} Kg/ person</strong></p>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}


                            </div>
                          </>
                        )}
                        {rF && rF.length > 0 && (
                          <>
                            <div className="row">
                              {rF.map((segment, index) => (
                                <div className="col-lg-12" key={index}>
                                  <p className="departure"><i className="fa fa-plane"></i> Return</p>
                                  <div className="row">
                                    <div className="col-md-2">
                                      <div className="flight_img">
                                        <img className="img_icon" src={`/assets/images/Flight_Images/${segment.marketingCarrier}.gif`} alt="flight" />
                                      </div>
                                      <div className="name_code">
                                        <span>{segment.airLineCode} - {segment.flightNumber}</span>
                                        <span>{segment.airLineName}</span>
                                      </div>
                                    </div>
                                    <div className="col-md-10">
                                      <div className="row">
                                        <div className="row"><div className="col-md-4 col-lg-4"></div><div className="col-md-3 col-lg-3"></div><div className="col-md-4 col-lg-4 offset-1"></div></div>
                                        <div className="col-md-3">
                                          <div className="timer">
                                            <p>{segment.departCityName}</p>
                                            <h4>{segment.departAirportCode} <span>|</span> {segment.departDateTime.split('T')[1].substring(0, 5)}</h4>
                                            <p className="dat_Adres"> {new Date(segment.departDateTime).toLocaleString("en-US", {
                                              weekday: "short",
                                              day: "numeric",
                                              month: "short",
                                              year: "numeric",
                                              // hour: "2-digit",
                                              // minute: "2-digit",
                                              hour12: false
                                            })}</p>
                                            <p className="dat_Adres">{segment.departAirportName}, {segment.departTerminal == "" ? "" : "Terminal " + segment.departTerminal}</p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="deruation">
                                            {segment.viaSector && segment.viaSector.trim() !== "" && segment.numberOfStops > 0 ? (
                                              <p>{segment.duration}  |  {segment.numberOfStops} STOP | {segment.viaSector}</p>
                                            ) : (
                                              <p>{segment.duration}  |  {segment.numberOfStops} STOP </p>
                                            )}

                                            <div className="bordr_top"><i className="fa fa-plane"></i></div>
                                            <p className="">
                                              {segment.travelClass && segment.travelClass.trim() !== "" && (
                                                <span>{segment.travelClass}</span>
                                              )}

                                              {flightAvailibilies[0].isRefundable ? (
                                                <span>Partially Refundable</span>
                                              ) : (
                                                <span>Non-Refundable</span>
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          <div className="timer">
                                            <p>{segment.arrivalCityName}</p>
                                            <h4>{segment.arrivalAirportCode} <span>|</span> {segment.arrivalDateTime.split('T')[1].substring(0, 5)}</h4>
                                            <p className="dat_Adres">{new Date(segment.arrivalDateTime).toLocaleString("en-US", {
                                              weekday: "short",
                                              day: "numeric",
                                              month: "short",
                                              year: "numeric",
                                              // hour: "2-digit",
                                              // minute: "2-digit",
                                              hour12: false
                                            })}</p>
                                            <p className="dat_Adres">{segment.arrivalAirportName}, {segment.arrivalTerminal == "" ? "" : "Terminal " + segment.arrivalTerminal}</p>
                                          </div>
                                        </div>
                                        <div className="col-md-3">
                                          {segment.baggageDetails && segment.baggageDetails.length > 0 && (
                                            <div className="baggage">
                                              <h5><i className="fa fa-suitcase"></i> Baggage information</h5>
                                              <p>Check-in :<strong>{segment.baggageDetails[0].baggage} Kg / person</strong></p>
                                              <p>Cabin :<strong>{segment.baggageDetails[0].cabinBaggage} Kg/ person</strong></p>
                                            </div>
                                          )}
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </>
                    )
                  )}
                </div>
                <div>
                  <div className="col-md-12 col-lg-12">
                    <h4 className="sub_heading">Payment</h4>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="paymnt">
                          <div className="paymnt_lft">
                            <ul className="nav nav-tabs paynt" role="tablist">
                              <li className="nav-item">
                                <a className="nav-link" active data-bs-toggle="tab" href="#CreditCard">Credit Card</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">Debit Card</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">Net Banking</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="tab" href="#CreditCard">UPI</a>
                              </li>
                            </ul>
                          </div>
                          <div className="paymnt_Rgt">
                            <div className="tab-content">
                              <div id="CreditCard" className="container tab-pane active">
                                <div className="balnce">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="HdfcBank"
                                    id="HdfcBankRadio"
                                    value="HdfcBank"
                                    checked={paymentMethod === "HdfcBank"}
                                    onChange={(e) => {
                                      setPaymentMethod(e.target.value)
                                      setPaymentError("");
                                    }
                                    }
                                  />
                                  <img src="/assets/images/hdfc-logo.png" alt="payment" /> </div>
                              </div>
                              <div id="DebitCard" className="container tab-pane fade">
                                <div className="balnce">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="paymentMethod"
                                    id="debitCardRadio"
                                    value="DebitCard"
                                    checked={paymentMethod === "DebitCard"}
                                    onChange={(e) => {
                                      setPaymentMethod(e.target.value)
                                      setPaymentError("");
                                    }}
                                  />
                                  <img src="/assets/images/hdfc-logo.png" alt="payment" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {paymentError && (
                          <div className="alert alert-danger fw-bold mt-3 py-2">
                            {paymentError}
                          </div>
                        )}
                      </div>

                      <div className="col-md-12 mt-5 mb-5">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            id="termsCheckbox"
                            name="Status"
                            type="checkbox"
                            checked={acceptedTerms}
                            onChange={(e) => {
                              setAcceptedTerms(e.target.checked);
                              if (e.target.checked) setTermsError("");
                            }}
                          />
                          {/* <input className="form-check-input" id="Active" name="Status" type="checkbox" value="1" /> */}
                          <label className="form-check-label Active" for="Active"> By clicking this button, I understand &amp; accept with the	Rules &amp; Restrictions of this fare,the Privacy Policy
                            <span data-bs-toggle="modal" data-bs-target="#term-cond" className="weak">Terms &amp; Conditions</span></label>
                        </div>
                        {termsError && (
                          <div className="alert alert-danger fw-bold mt-3 py-2">
                            {termsError}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {success && (
                    <div className="col-md-12 mt-3 mb-4">
                      <div className="alert alert-success text-center fw-bold py-2 rounded">
                        {success}
                      </div>
                    </div>
                  )}

                  <div className="button-list">
                    <button className="btn btn-primary" onClick={handlePaymentSubmit}>
                      Pay & Book
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-3 po_sticky'>
              <div className='box_shadow sticky'>
                <h6>Fare Summary</h6>
                <div className="accordion" id="kt_accordion_1">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="kt_accordion_1_header_1">
                      <button className="accordion-button fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_1" aria-expanded="true" aria-controls="kt_accordion_1_body_1">
                        <div className='flex'>
                          <span> Base Fare</span>
                          <span><i className='fa fa-inr'></i> {totalBFare.toFixed(2)} </span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_1" className="accordion-collapse collapse show" aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
                      <div className="accordion-body">

                        {flightDetails && flightDetails.airBookingResponse.length > 0 && flightDetails.airBookingResponse[0].adult > 0 && (
                          <div className='flex'>
                            <span>{paxCount[0].adult} Adult(s)</span>
                            <span>
                              <i className="fa fa-inr"></i> {adultTotalBaseFare.toFixed(2)}
                            </span>
                          </div>
                        )}

                        {flightDetails && flightDetails.airBookingResponse.length > 0 && flightDetails.airBookingResponse[0].child > 0 && (
                          <div className='flex'>
                            <span>{paxCount[0].child} Child(s)</span>
                            <span>
                              <i className="fa fa-inr"></i> {childTotalBaseFare.toFixed(2)}
                            </span>
                          </div>
                        )}

                        {flightDetails && flightDetails.airBookingResponse.length > 0 && flightDetails.airBookingResponse[0].infant > 0 && (
                          <div className='flex'>
                            <span>{paxCount[0].infant} Infant(s)</span>
                            <span>
                              <i className="fa fa-inr"></i> {infantTotalBaseFare.toFixed(2)}
                            </span>
                          </div>
                        )}

                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="kt_accordion_1_header_2">
                      <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_2" aria-expanded="false" aria-controls="kt_accordion_1_body_2">
                        <div className='flex'>
                          <span>Fee & Surcharges</span>
                          <span> <i className='fa fa-inr'></i> {flightDetails &&
                            (
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.totalOtherTax || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.totalServiceTax || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.managementFee || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.baggageCharge || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.mealCharge || 0),
                                0
                              ) +
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.managementFeeTax || 0),
                                0
                              )
                            ).toFixed(2)}</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_2" className="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_2" data-bs-parent="#kt_accordion_1">
                      <div className="accordion-body">
                        <div className='flex'>
                          <span>Baggage Charge <i class="fa-regular fa-circle-xmark"></i></span>
                          <span><i className='fa fa-inr'></i>
                            {flightAvailibilies &&
                              flightAvailibilies
                                .reduce((sum, x) => sum + parseFloat(x.fareDetails?.baggageCharge || 0), 0)
                                .toFixed(2)}</span>
                        </div>
                        <div className='flex'>
                          <span>Meal Charge <i class="fa-regular fa-circle-xmark"></i></span>
                          <span><i className='fa fa-inr'></i>{flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.mealCharge || 0), 0)
                              .toFixed(2)} </span>
                        </div>
                        <div className='flex'>
                          <span> Fuel Surcharge</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.totalFuelSurcharge || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                        <div className='flex'>
                          <span> Tax</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            (
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.totalOtherTax || 0),
                                0
                              ) -
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.gSTAmount || 0),
                                0
                              ) -
                              flightAvailibilies.reduce(
                                (sum, x) => sum + parseFloat(x.fareDetails?.totalFuelSurcharge || 0),
                                0
                              )
                            ).toFixed(2)}</span>
                        </div>

                        <div className='flex'>
                          <span> Booking Surcharge</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.managementFee || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="kt_accordion_1_header_3">
                      <button className="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#kt_accordion_1_body_3" aria-expanded="false" aria-controls="kt_accordion_1_body_3">
                        <div className='flex'>
                          <span>Total Fare</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.totalFare || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                      </button>
                    </h2>
                    <div id="kt_accordion_1_body_3" className="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_3" data-bs-parent="#kt_accordion_1">
                      <div className="accordion-body">
                        <div className='flex'>
                          <span> Markup</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.agencyMarkUp || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                        <div className='flex'>
                          <span> Commission</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.agencyCommission || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                        <div className='flex'>
                          <span> Net Fare</span>
                          <span><i className='fa fa-inr'></i> {flightAvailibilies &&
                            flightAvailibilies
                              .reduce((sum, x) => sum + parseFloat(x.fareDetails?.agencyAmount || 0), 0)
                              .toFixed(2)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='d-flexes'>
                  <div className='totals'>GRAND TOTAL</div>
                  <div className='tolt_price'><i className='fa fa-inr'></i> {flightAvailibilies &&
                    flightAvailibilies
                      .reduce((sum, x) => sum + parseFloat(x.fareDetails?.totalFare || 0), 0)
                      .toFixed(2)}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section >



    </>
  )
};

export default PayNBook;
